<template>
  <v-form ref="cardForm" v-model="valid" :id="'textCard'+id">
    <editor
      outlined
      ref="toastuiEditor"
      initialEditType="wysiwyg"
      :initialValue="textProp"
      :options="{ hideModeSwitch: true }"
      @change="onEditorChange"
      label="Ficha del proyecto"
      :key="'t'+id+editorKey"
      required
    />
  </v-form>
</template>
<script>
import { Editor } from '@toast-ui/vue-editor';
export default {
  props:{
    id:{
      type:String
    },
    cardTitle: {
      type: String,
      default: ''
    },
    preRegisteredValues: {
      type:Object
    }
  },
  components:{
    Editor
  },
  data(){
    return {
      valid: false,
      updated:false,
      text:(this.preRegisteredValues!==undefined)?this.preRegisteredValues.text:'',
      compiledMarkdown:false,
      requiredRule: [
        v => !!v || 'Este campo es obligatorio.'
      ],
      editorKey:0
    }
  },
  computed:{
    textProp:{
      get(){
        return this.text
      },
      set(value){
        this.updated = true
        this.text = value
      }

    }
  },
  methods:{
    toggleText(){
      this.compiledMarkdown = !this.compiledMarkdown
    },
    onEditorChange() {
      this.textProp=this.$refs.toastuiEditor.invoke('getMarkdown');
    },
    emitCardInfo(){
      this.$refs.cardForm.validate()
      if(this.valid){
        var event = 'getCardInfo'
        var card= {
          name: this.cardTitle,
          cardType: 3
        }
        if(this.preRegisteredValues !== undefined){
          if(this.text !== this.preRegisteredValues.text){
            card.text = this.text
          }
          card.projectCardId = this.preRegisteredValues.projectCardId
        } else {
          card.text = this.text
        }
       
        this.$emit(event, card)
      }
    }
  },
  watch:{
    preRegisteredValues(newVal,oldVal){
      if(newVal!==oldVal)
        this.editorKey++
    }
  }
}
</script>